import { StateType } from '../index';
import { createSelector } from 'reselect';
import { LanguageField } from '../../actions/EditorActions/EditorActions';

export const languageFieldsFetchingSelector = (state: StateType) => state.getIn(['language_fields', 'fetching']) as boolean;

export const languageFieldsSelector = (state: StateType) => state.getIn(['language_fields', 'fields']);

export const languageSelectionSelector = (state: StateType) => state.getIn(['language_fields', 'selection']);

export const languageComboSelector = (state: StateType) => state.getIn(['language_fields', 'combo']);

export const languageFieldIdsSelector = createSelector(
  languageFieldsSelector,
  fields => (fields as any)?.toJS()?.map(({ id }: LanguageField) => id) ?? []
);

export const languageSelectionIdsSelector = createSelector(
  languageSelectionSelector,
  selections => (selections as any)?.toJS()?.map(({ id }: LanguageField) => id) ?? []
);

export const languageComboIdsSelector = createSelector(
  languageComboSelector,
  combos => (combos as any)?.toJS()?.map(({ id }: LanguageField) => id) ?? []
);
